import React from "react";
import "./App.css";
import "./design-system.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { ServiceSearch } from "./components/ServiceSearch";
import { TaxCredit } from "./components/TaxCredit";
import { ServicesSection } from "./components/ServicesSection";
import { Advantages } from "./components/Advantages";
import { BeforeAfter } from "./components/BeforeAfter";
import { Testimonials } from "./components/Testimonials";
import { Recruitment } from "./components/Recruitment";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { TMCPage } from "./components/TMCPage";
import { ServicePage } from "./components/ServicePage";
import { PremiumQuoteTunnel } from "./components/PremiumQuoteTunnel";
import { CreditImpotPage } from "./components/CreditImpotPage";
import { CandidaturePage } from "./components/CandidaturePage";
import { TarifsPage } from "./components/TarifsPage";
import { AppointmentBooking } from "./components/AppointmentBooking";
import { FloatingBookButton } from "./components/FloatingBookButton";
import { AdminDashboard } from "./components/AdminDashboard";
import { Toaster } from "./components/ui/sonner";
import { PartnersLogos } from "./components/PartnersLogos";
import { Newsletter } from "./components/Newsletter";
import { InteractiveMap } from "./components/InteractiveMap";
import { ScrollToTop } from "./components/ScrollToTop";
import { FAQ } from "./components/FAQ";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ServiceSearch />
      <TaxCredit />
      <ServicesSection />
      <InteractiveMap />
      <Advantages />
      <BeforeAfter />
      <Testimonials />
      <Newsletter />
      <Recruitment />
      <Contact />
      <FAQ />
      <PartnersLogos />
      <Footer />
      <FloatingBookButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tmc" element={<><Header /><TMCPage /><Footer /></>} />
          <Route path="/service/:serviceId" element={<ServicePage />} />
          <Route path="/devis-premium" element={<><Header /><PremiumQuoteTunnel /><Footer /></>} />
          <Route path="/credit-impot" element={<><Header /><CreditImpotPage /><Footer /></>} />
          <Route path="/candidature" element={<><Header /><CandidaturePage /><Footer /></>} />
          <Route path="/tarifs" element={<TarifsPage />} />
          <Route path="/rendez-vous" element={<AppointmentBooking />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <ScrollToTop />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
